<template>
    <div>
        <div class="container-fluid container-search-bg">
            <div class="container">
                <h1 class="text-center text-white">
                    <b>{{trans('vue.footer_empaso')}}</b>
                </h1>
                <template v-if="companies.data">
                    <h3 class="text-center text-white h5">{{trans('vue.textos_latest_registered_companies')}}</h3>
                </template>
            </div>
        </div>
        <div class="container-fluid">
            <div class="container">
                <div class="row">
                    <search v-loading="loading" @companies="getCompanies" @loading-effect="loading" :page="current_page" :parameters="parameters" :countries="countries" :regions_old="regions"></search>
                    
                    <div class="col-12 col-lg-8">
                        <template v-if="companies.data">
                            <div class="row">
                                <template v-for="(company, index) in companies.data">
                                    <company :company="company" :countries="countries" :regions="regions"></company>
                                </template>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="companies.meta">
            <div class="block col-md-12 text-center">
                <el-pagination layout="prev, pager, next"
                       :page-count="companies.meta.last_page"
                       @current-change="currentChange"
                       :current-page.sync="companies.meta.current_page">
                </el-pagination>
                <span class="demonstration">Mostrando {{companies.meta.last_page}} - {{companies.meta.per_page}} de {{companies.meta.total}} resultados en total</span>
            </div>
        </template>
    </div>
</template>

<script>
    import search from './SearchCompanies.vue';
    import company from './Company.vue';
    export default {
        name: "Companies",
        components:{
            search:search,
            company:company,
        },
        props:['parameters', 'countries', 'regions'],
        data (){
            return {
                companies: [],
                page: false,
                current_page:1,
                loading:true,
            }
        },
        methods: {
            loading(loading) {
                this.loading = loading;
            },
            getCompanies(companies){
                this.companies = companies;
                this.loading = false;

            },
            currentChange(){
                this.current_page=this.companies.meta.current_page;
                this.page = true;
            },
            trans(value){
                if (!value) return '';
                return  _.get(window.i18n, value);
            },
        },
        filters: {
            translate: function (value) {
                if (!value) return '';
                return _.get(window.i18n, value);
            }
        },
        watch:{
            courses() {
                this.page = false

            }
        }
    }
</script>

<style scoped>

</style>
